

export class Settings {
    dontSwitchPlayer: boolean = false;


}